<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Security.User.username")' @keyup.enter.native="filterAccount" maxLength='20'></ejs-textbox>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="accountMonitorData" :allowPaging="false" ref="grid"  :height="screenHeight">
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="userId" :visible="false"></e-column>
            <e-column field="username" :headerText="$t('Security.User.username')" width="120" textAlign="Center"></e-column>
            <e-column field="roleIdList" :headerText="$t('Security.Role.name')" width="120" textAlign="Center"></e-column>
            <e-column field="ip" :headerText="$t('Security.Log.ip')" width="120" textAlign="Center"></e-column>
            <e-column field="lastOperateTime" :headerText="$t('Security.User.operatetime')" :format="dateFormat" width="120" textAlign="Center"></e-column>
            <e-column field="idleTime" :headerText="$t('Security.User.idletime')" :formatter="idletimeFormat" width="120" textAlign="Center" ></e-column>
            <e-column field="loginTime" :headerText="$t('Security.Log.loginTime')" :format="dateFormat" width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';

export default {
  name: 'accountMonitor',
  data() {
    return {
      accountMonitorData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.accountMonitor')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-forced-return', tooltipText: this.$t('Security.User.force'), click: this.forceAccount },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid }
      ],
      keyword: '',
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },

      addIndex: 0,
      editId: '',
      addStatus: true,
      screenHeight: document.body.clientHeight - 240
    };
  },
  components: {
    BasicLayout,
    CustomDialog,
  },
  mounted() {
    this.getAccountMonitorList();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  methods: {
    getAccountMonitorList() {
      const url = '/lte/ems/user/queryUserOperate';
    //   this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        username: this.keyword
        // pageNo: this.page.pageNo,
        // pageSize: this.pageSettings.pageSize
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          let date = new Date();
          date.setTime(v.lastOperateTime);
          v.lastOperateTime = date;

          let logindate = new Date();
          logindate.setTime(v.loginTime);
          v.loginTime = logindate;
        });
        That.accountMonitorData = result;
        // That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    idletimeFormat(grid, data) {
        let str = Math.ceil(Number(data.idleTime)/(60*1000));
        data.idleTime = str;
        return str;
    },
    filterAccount() {
      this.getAccountMonitorList();
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },

    forceAccount() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      const url = '/lte/ems/user/forceExit';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.username);
      });
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmForce')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                That.getAccountMonitorList();
              } else {
                That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
      });
    },

    refreshGrid() {
      this.getAccountMonitorList();
    },
    copyDeep(templateData) {
      const returnData = JSON.parse(JSON.stringify(templateData));
      returnData.buttonGroup.forEach((item, index) => {
        item.click = templateData.buttonGroup[index].click;
      });
      return returnData;
    }
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
